import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { WindowMU } from "app/types/WindowMU"
import globalMU from "globalMU"

declare var window:WindowMU

export type RegistrarPerdaCotacaoInput = {
    ItenSelecionados:number[]
    ManterItem:boolean
    Observacao:string
    CodigoConcorrente:number
    PrecoConcorrente:number
    CodigoMotivo:number
    Quantidade:number
    PerdaCotacaoTodosItens: boolean // 470698
}

export async function registrarPerdaCotacao(input:RegistrarPerdaCotacaoInput) { // atenção no editar itens, se o parametro ACEITAR_PRODUTO_SEM_ESTOQUE != S é possivel gerar cotacao perdida por lá
    try {
       // globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.salvarRegistroPerdaCotacao(
            store.getState().orcamento.IdentificadorOrcamento, // atenção no editar itens, se o parametro ACEITAR_PRODUTO_SEM_ESTOQUE != S é possivel gerar cotacao perdida por lá
            input
        );

        window.orcamentoController.model.atualizar(orcamentoAtualizado,true,true)
        
    } finally {
        // globalMU.unblockUI()
    }
}